import { AuthorizationScope } from '../AuthorizationScope'

const scope: AuthorizationScope = {
  _id: 'WORKSPACE_PROJECT_UTILITY_UNIT_OF_MEASUREMENT',
  name: 'Workspace Project Utility Unit Of Measurement',
  type: 'PROJECT',
  description: '',
  modules: [],
  fields: [
    { key: 'name', title: 'Unit of measurement name' },
    { key: 'type', title: 'Unit of measurement type' },
    { key: 'symbol', title: 'Unit of measurement symbol' },
    { key: 'direction', title: 'Unit of measurement direction' },
    { key: 'allowDecimal', title: 'Allow Decimal' },
    { key: 'numberOfDecimals', title: 'Number of decimals' },
  ],
  related: ['WORKSPACE_PROJECT_METRIC', 'WORKSPACE_PROJECT_MEASUREMENT_POINTS'],
  actions: ['READ', 'CREATE', 'UPDATE', 'UPLOAD', 'DESTROY'],
}

export default scope
